// @ts-nocheck
import React from "react";
import {useNavigate} from "react-router-dom";
import fallbackImage from "../../../../../assets/images/fallback-image.svg";
import VirtualSportsImg from "../../../../../assets/images/home-games-display/virtual-sports.webp";
import {useAuthStore} from "../../../../../store/useAuth.store";
import {useMiniGames} from "../../../../../store/useMiniGames";
import {
  displayCharacterCls,
  displayCharBtnCls,
  displayCharOverlayCls,
  displayCharTitleCls,
  displayGameCardCls,
  displayGameCardLoadingCls,
  displayGameCardOverlayCls,
  displayGameCardPlayCls,
  displayGameIconCls,
  displayLeftCls,
  displayRightCls,
  displayRowCls,
  displaySectionTopBottom,
} from "../_displayShared";

const VirtualSportsDisplay = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const allGames = useMiniGames(state => state.list);
  const isLoading = useMiniGames(state => state.loading);

  const topVirtual = React.useMemo(() => {
    if (!allGames.length) return [];
    return allGames.filter(game => game.class === "instant").slice(0, 12);
  }, [allGames]);

  const row1 = topVirtual.slice(0, 6);
  const row2 = topVirtual.slice(6, 12);
  const placeholders = Array.from({length: 6});

  const renderCard = (game, idx) =>
    game ? (
      <div
        key={game.id || idx}
        className={displayGameCardCls}
        onClick={() =>
          authStatus === "authenticated" ? navigate(`/games/${game.provider}/${game.id}`) : handleShowAuthModal()
        }
      >
        <img
          src={game.icon || fallbackImage}
          alt={game.name}
          onError={e => {
            e.target.onerror = null;
            e.target.src = fallbackImage;
          }}
          className={displayGameIconCls}
        />
        <div
          className={displayGameCardOverlayCls}
          aria-hidden="true"
        >
          <span className={displayGameCardPlayCls}>▶</span>
        </div>
      </div>
    ) : (
      <div
        key={`ph-${idx}`}
        className={`${displayGameCardCls} ${displayGameCardLoadingCls}`}
      />
    );

  return (
    <div className={displaySectionTopBottom}>
      {/* Left: image with overlay */}
      <div className={displayLeftCls}>
        <img
          src={VirtualSportsImg}
          alt="Virtual Sports background"
          className={displayCharacterCls}
        />
        <div className={displayCharOverlayCls}>
          <span className={displayCharTitleCls}>Virtual Sports</span>
          <button
            className={displayCharBtnCls}
            type="button"
            onClick={() =>
              authStatus === "authenticated" ? navigate("/games/pragmatic/vplobby") : handleShowAuthModal()
            }
          >
            Ir a todos
          </button>
        </div>
      </div>

      {/* Right: 6×2 grid */}
      <div className={displayRightCls}>
        <div className={displayRowCls}>
          {(isLoading || !topVirtual.length ? placeholders : row1).map((g, i) => renderCard(g, i))}
        </div>
        <div className={displayRowCls}>
          {(isLoading || !topVirtual.length ? placeholders : row2).map((g, i) => renderCard(g, i + 6))}
        </div>
      </div>
    </div>
  );
};

export default VirtualSportsDisplay;
